<template>
  <div class="restbooktimeset" :style="{ gridTemplateColumns: '1fr 1fr' }">
    <div>
      <editBox :label="'宅配設定'" :color="'#CC9B6D'" @edit="edit=$event ? 3 : null" :edit="edit===3" @save="save">
        <template slot="edit" v-if="edit===3">
          <div class="containerB-box"><span>宅配功能</span> <RT :bg="'#CC9B6D'" :options="['開放宅配', '關閉']" :width="'125px'" :defaultValue="info.restDeliver ? '開放宅配' : '關閉'"/></div>
          <div class="inputtimeselect">
            <label for="infinity"><input type="radio" id="infinity" v-model="editItem.Infinity" :value="true">無期限</label>
          </div>
          <div class="inputtimeselect">
            <label for="limit"><input type="radio" id="limit" v-model="editItem.Infinity" :value="false">開放宅配功能日期</label>
            <RangeInput :style="{marginLeft: '25px', width: '350px'}" :defaultValue="editItem.range" @input="editItem.Infinity=false;editItem.range=$event "/>
          </div>
        </template>
        <template>
          <div class="containerB-box">
            <span>宅配功能</span>
            <RT :bg="'#CC9B6D'" :options="['開放宅配', '關閉']" :width="'125px'" :disabled="true" :defaultValue="info.restDeliver ? '開放宅配' : '關閉'" @input="info.restDeliver=$event === '開放宅配'"/>
          </div>
          <template v-if="info.restDeliver">
            <div class="inputtimeselect" v-if="info.restDeliverFnRange?.Infinity">無期限開放宅配功能</div>
            <div class="inputtimeselect" v-else>開放宅配功能日期
              <div class="rangeView">{{ toDate(info.restDeliverFnRange?.start) }} - {{ toDate(info.restDeliverFnRange?.end) }}</div>
            </div>
          </template>
        </template>
      </editBox>
    <editBox :label="'宅配日範圍設定'" :color="'#CC9B6D'" @edit="edit=$event ? 4 : null" :edit="edit===4" @save="save">
      <div class="takeRange" v-if="info.restDeliverAvaRange?.mode===1">開放<template v-if="info.restDeliverAvaRange?.start?.unit==='hours'||info.restDeliverAvaRange?.start?.unit==='minutes'">當天</template> <span class="num">{{info.restDeliverAvaRange?.start?.value}}</span> <span>{{units[info.restDeliverAvaRange?.start?.unit]}}</span>後到 <span class="num">{{info.restDeliverAvaRange?.end?.value}}</span> <span>{{units[info.restDeliverAvaRange?.end?.unit]}}</span>前希望到貨日。</div>
      <div class="takeRange" v-else-if="info.restDeliverAvaRange?.mode===2">開放 <div class="rangeView"  :style="{marginInline: '.5em'}">{{ toDate(info.restDeliverAvaRange?.range?.start) }} - {{ toDate(info.restDeliverAvaRange?.range?.end) }}</div> 希望到貨日。</div>
      <template slot="edit" v-if="edit===4">
        <div class="inputtimeselect">
          <label for="infinity"><input type="radio" id="infinity" v-model="editItem.mode" :value="1"></label>
          <div class="takeRangeEdit" :style="{marginLeft: '20px'}">開放
            <input type="text" v-model.number="editItem.start.value">
            <select v-model="editItem.start.unit">
              <option value="days">天</option>
              <option value="weeks">週</option>
              <option value="months">月</option>
            </select>
            後到
            <input type="text" v-model.number="editItem.end.value">
            <select v-model="editItem.end.unit">
              <option value="days">天</option>
              <option value="weeks">週</option>
              <option value="months">月</option>
            </select>
            前希望到貨日。
          </div>
        </div>
        <div class="inputtimeselect">
          <label for="infinity"><input type="radio" id="infinity" v-model="editItem.mode" :value="2"></label>
          <div class="inputRangeflex">
            開放 <RangeInput :style="{width: '350px'}" :defaultValue="editItem.range" @input="editItem.mode=2;editItem.range=$event "/> 取貨。
          </div>
        </div>
      </template>
    </editBox>
    <editBox :label="'宅配付款方式'" :color="'#CC9B6D'" @edit="edit=$event ? 5 : null" :edit="edit===5" @save="save">
      <template>
        <div v-if="info.onlinePaymentDeliver.enabled" class="showMethod">
            <span>付款方式 <span :style="{fontSize:'16px', color: '#999999'}">滑鼠托拽方塊可進行排序</span></span>
            <draggable :value="sortedMethods" @input="sortedMethods=$event">
              <div v-for="(method, m) in sortedMethods" :key="`showMethod-${m}`">{{method}}</div>
            </draggable>
            <BtnsS v-if="sortedMethods.join('_')!==info.onlinePaymentDeliver.methods.join('_')"
            @cancel="sortedMethods=info.onlinePaymentDeliver?.methods || []" :save="'儲存排序'"
            @save="$emit('update', { 'onlinePaymentDeliver.methods': sortedMethods })"/>
        </div>
        <div v-else class="showMethod">無付款方式，僅人工收單處理</div>
      </template>
      <template slot="edit" v-if="edit===5">
        <div class="inputtimeselect">
          <label for="enabledtrue"><input type="radio" id="enabledtrue" v-model="editItem.enabled" :value="false">無付款方式，僅人工收單處理</label>
        </div>
        <div class="inputtimeselect">
          <label for="enabledfalse"><input type="radio" id="enabledfalse" v-model="editItem.enabled" :value="true">需選擇付款方式</label>
        </div>
        <div class="flexWrap" v-if="editItem.enabled">
          <div class="switchspay">
            <div class="switch" v-for="(method, m) in methods" :key="`method-${m}`" :label="method">
              <input type="checkbox" v-model="editItem.methods" :value="method">
            </div>
          </div>
        </div>
      </template>
    </editBox>
    <editBox :label="'離島宅配'" @edit="edit=$event ? 7 : null" :edit="edit===7" @save="save">
      <RT :bg="'#CC9B6D'" :options="['開放離島宅配', '關閉']" :width="'155px'" :disabled="true" :defaultValue="info.restDeliverOutlying ? '開放離島宅配' : '關閉'" @input="info.restDeliverOutlying=$event === '開放離島宅配'"/>
      <RT :bg="'#CC9B6D'" :options="['開放離島宅配', '關閉']" :width="'155px'" :defaultValue="editItem ? '開放離島宅配' : '關閉'" @input="editItem=$event === '開放離島宅配'" slot="edit"/>
    </editBox>
    <editBox :label="'宅配運費計算'" :color="'#CC9B6D'" @edit="edit=$event ? 6 : null" :edit="edit===6" @save="save" v-if="deliverFees">
      <div class="temperatures edit" v-if="edit===6" slot="edit">
        <template v-for="temperature in ['常溫', '冷藏', '冷凍']">
        <div v-for="outlying in info.restDeliverOutlying ? ['本島', '離島'] : ['本島']" :key="`${temperature}-${outlying}`">
            <div :style="{fontWeight: '900', textDecoration: 'underline'}">{{temperature}} ({{outlying}})</div>
            <div v-for="(cond, c) in editItem[`${temperature}_${outlying}`]" :key="`${temperature}-${outlying}-${c}`">
              <div class="editline">消費:
                <span v-if="!editItem[`${temperature}_${outlying}`][c+1]">滿</span>
                <input type="text" v-model="editItem[`${temperature}_${outlying}`][c].start" @change="udpatePreOne(temperature, c)">
                <span v-if="editItem[`${temperature}_${outlying}`][c+1]">~ {{editItem[`${temperature}_${outlying}`][c].end}}</span> 元</div>
              <div :style="{marginInline:'auto'}"></div>
              <div class="editline">運費: <input type="text" v-model="editItem[`${temperature}_${outlying}`][c].price"></div>
              <div class="addbox" v-if="c>0&&c<(editItem[`${temperature}_${outlying}`].length - 1)">
                <button class="add" @click="editItem[`${temperature}_${outlying}`].splice(c+1, 0, {
                  start: editItem[`${temperature}_${outlying}`][c].end,
                  end: editItem[`${temperature}_${outlying}`][c].end,
                  price: editItem[`${temperature}_${outlying}`][c].price })"/>
                <button class="remove" @click="editItem[`${temperature}_${outlying}`].splice(c, 1)" />
              </div>
              <div v-else class="addbox"/>
            </div>
        </div>
        </template>
      </div>
      <div class="temperatures" v-else :class="info.restDeliverOutlying?'outlying':''">
          <template v-for="temperature in ['常溫', '冷藏', '冷凍']">
        <div v-for="outlying in info.restDeliverOutlying ? ['本島', '離島'] : ['本島']" :key="`${temperature}-${outlying}`">
            <div :style="{fontWeight: '900', textDecoration: 'underline'}">{{temperature}} ({{outlying}})</div>
            <div v-for="(cond, c) in deliverFees[`${temperature}_${outlying}`]" :key="`${temperature}-${outlying}-${c}`">
              <div class="editline" v-if="cond.end">消費: {{cond.start}} ~ {{cond.end}} 元</div>
              <div class="editline" v-else>消費: 滿 {{cond.start}} 元</div>
              <div :style="{marginInline:'auto'}"></div>
              <div class="editline" v-if="cond.price">運費: {{formatDollarInt(cond.price)}} 元</div>
              <div class="editline" v-else>免運</div>
            </div>
          </div>
          </template>

      </div>
    </editBox>
    </div>
    <div>
      <editCube :style="{marginBlock: 0, paddingBottom: 0}" :pstyle="{border: 'none', padding: 0}" :title="'匯款資訊'" :color="'#CC9B6D'"
      :defaultValue="info.restGoodsPayInfo" @save="$emit('update', {restGoodsPayInfo:$event})"/>
      <editCube :style="{marginBlock: 0, paddingBottom: 0}" :title="'匯款成功說明'" :color="'#CC9B6D'" :defaultValue="info.restGoodsPaySuccess" @save="$emit('update', {restGoodsPaySuccess:$event})"/>
      <editCube :style="{marginBlock: 0}" :title="'匯款-狀態查詢'" :color="'#CC9B6D'" :defaultValue="info.restGoodsPayStatusCheck" @save="$emit('update', {restGoodsPayStatusCheck:$event})"/>
      <editCube :title="'宅配運費說明(顯示於購物車頁面)'"  :defaultValue="info.descCart||''" @save="update({descCart:$event})">
        <switchVue :defaultValue="info.showDescCart" @update="update({showDescCart:$event})"/>
      </editCube>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import switchVue from '../../components/radio/switch.vue'
import editCube from '../../components/editCubeV2.vue'
import RangeInput from '../../components/input/dateRange.vue'
import RT from '../../components/radio/r1.vue'
import editBox from './editBox.vue'
import { getapi, postapi } from '../../store/fetch'
export default {
  name: 'restBookSummarySet',
  props: ['info'],
  components: {
    editBox,
    RT,
    RangeInput,
    editCube,
    switchVue,
    draggable
  },
  data () {
    return {
      edit: null,
      restRatioHoliday: 0,
      restRatioWeekday: 0,
      editItem: null,
      wdy: ['日', '一', '二', '三', '四', '五', '六'],
      sortedMethods: [],
      units: {
        minutes: '分鐘',
        hours: '小時',
        days: '天',
        weeks: '週',
        months: '月'
      },
      methods: ['匯款', '信用卡', 'LINE PAY', '貨到付款'],
      deliverFees: null
    }
  },
  computed: {
  },
  async mounted () {
    this.deliverFees = await getapi(`deliverFee/${this.info.name}`)
  },
  watch: {
    editItem: {
      deep: true,
      handler () {
        if (this.edit === 6) {
          ['常溫_本島', '冷藏_本島', '冷凍_本島', '常溫_離島', '冷藏_離島', '冷凍_離島'].map(temperature => {
            for (let i = 0; i < this.editItem[temperature].length; i = i + 1) {
              if (i > 0) {
                this.editItem[temperature][i - 1].end = this.editItem[temperature][i].start - 1
              }
            }
          })
        }
      }
    },
    edit () {
      switch (this.edit) {
        case 3:
          this.editItem = {
            restDeliver: this.info.restDeliver,
            Infinity: this.info.restDeliverFnRange?.Infinity,
            range: {
              start: this.moment(this.info.restDeliverFnRange?.start || null).format('yyyy-MM-DD'),
              end: this.moment(this.info.restDeliverFnRange?.end || null).format('yyyy-MM-DD')
            }
          }
          break
        case 4:
          this.editItem = this.info.restDeliverAvaRange ? {
            ...this.info.restDeliverAvaRange,
            ...(this.info.restDeliverAvaRange.start || { start: { value: 5, unit: 'days' } }),
            ...(this.info.restDeliverAvaRange.end || { end: { value: 180, unit: 'days' } }),
            ...(this.info.restDeliverAvaRange.range ? {
              range: {
                start: this.moment(this.info.restDeliverAvaRange.range.start).format('YYYY-MM-DD'),
                end: this.moment(this.info.restDeliverAvaRange.range.end).format('YYYY-MM-DD')
              }
            } : { range: { start: null, end: null } })
          } : {
            mode: 1,
            start: { value: 5, unit: 'days' },
            end: { value: 180, unit: 'days' },
            range: {
              start: null,
              end: null
            }
          }
          break
        case 5:
          this.editItem = this.info.onlinePaymentDeliver || {
            enabled: false,
            methods: []
          }
          break
        case 6:
          this.editItem = JSON.parse(JSON.stringify(this.deliverFees))
          break
        case 7:
          this.editItem = !!this.info.restDeliverOutlying
          break
      }
    },
    info: {
      deep: true,
      immediate: true,
      handler () {
        this.sortedMethods = this.info.onlinePaymentDeliver?.methods || []
      }
    }
  },
  methods: {
    update (value) {
      this.$emit('update', value)
    },
    async save () {
      switch (this.edit) {
        case 3:
          this.$emit('update', {
            restDeliver: this.editItem.restDeliver,
            restDeliverFnRange: {
              Infinity: this.editItem.Infinity,
              start: this.editItem.range.start ? this.moment(this.editItem.range.start).startOf('day').toISOString() : null,
              end: this.editItem.range.end ? this.moment(this.editItem.range.end).endOf('day').toISOString() : null
            }
          })
          break
        case 4:
          this.$emit('update',
            {
              restDeliverAvaRange: {
                mode: this.editItem.mode,
                ...(this.editItem.mode === 2 ? {
                  range: {
                    start: this.moment(this.editItem.range.start).startOf('day').toISOString(),
                    end: this.moment(this.editItem.range.end).endOf('day').toISOString()
                  }
                } : {
                  start: this.editItem.start, end: this.editItem.end
                })
              }
            }
          )
          break
        case 5:
          this.$emit('update', { onlinePaymentDeliver: this.editItem })
          break
        case 7:
          this.$emit('update', { restDeliverOutlying: this.editItem })
          break
        case 6:
          await this.saveDeliverFee()
      }
      this.edit = null
    },
    udpatePreOne (temperature, c) {
      if (this.editItem[temperature][c - 1]) {
        this.editItem[temperature][c - 1].end = this.editItem[temperature][c].start - 1
      }
    },
    async saveDeliverFee () {
      const ids = [].concat(...Object.values(this.editItem)).map(e => e._id).filter(e => e)
      const ids2 = [].concat(...Object.values(this.deliverFees)).map(e => e._id).filter(e => e)
      const idsRemove = ids2.filter(e => !ids.includes(e))
      const r = await postapi(`deliverFee/${this.info.name}`, {
        updateItem: { ...this.editItem },
        deleteItem: idsRemove
      })
      if (r) {
        this.deliverFees = await getapi(`deliverFee/${this.info.name}`)
        this.edit = null
      }
    }
  }

}
</script>
<style lang="scss">
.showMethod {
  font-size: 20px;
  text-align: start;
  display: flex;
  flex-direction: column;
  gap: 20px;
  &>div{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 20px;
    &>div {
      width: fit-content;
      padding-inline: 1em;
      border-radius: 5px;
      height: 70px;
      border: 2px dashed var(--color-pri);
      display: flex;
      align-items: center;
      justify-content: center;
      letter-spacing: .1em;
    }
  }
}
.switchspay {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 30px;
  .switch {
    width: 240px;
    height: 70px;
    border: 2px dashed var(--color-pri);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    font-size: 20px;
    border-radius: 5px;
    padding-inline: 20px;
    &::before {
      width: fit-content;
      content: attr(label);
    }
  }
  input[type=checkbox] {
    appearance: none;
    width: 39px;
    height: 20px;
    border-radius: 10px;
    position: relative;
      background-color: #FF8B8B;
    &:checked {
      background-color: var(--color-checked);
    }
    &::before {
      content: '';
      display: inline-flex;
      width: 16px;
      height: 16px;
      position: absolute;
      left: 2px;
      right: auto;
      top: 2px;
      background-color: #FFFFFF;
      border-radius: 8px;
    }
    &:checked::before {
      right: 2px;
      left: auto;
    }
    &.invert {
      background-color: var(--color-checked);
      &:checked {
        background-color: #FF8B8B;
      }
    }
  }
}
.inputRangeflex {
  display: flex;
  align-items: center;
  margin-left: 25px;
  gap: 10px;
}
.takeRangeEdit {
  text-align: start;
  font-size: 20px;
  letter-spacing: .1em;
  font-family: Roboto;
  color: #6D6D6D;
  display: flex;
  align-items: center;
  select {
    width: fit-content;
    color: #FF8B8B;
    font-weight: 700;
  }
  input[type=text] {
    width: 100px;
    text-align: center;
    width: 100px;
    height: 37px;
    border: 1px solid #CACACA;
    align-items: center;
    justify-content: center;
    letter-spacing: .05em;
    font-weight: 700;
    color: #FF8B8B;
    margin-inline: .5em;
  }

}
.takeRangeWeekend {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 40px;
  &>div.dot {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    font-size: 20px;
    &::before {
      border-radius: 10px;
      width: 10px;
      height: 10px;
      background-color: var(--color-pri);
      border:3px solid  #FFFFFF;
      outline: 1px solid var(--color-pri);
      display: inline-flex;
      content: '';
    }
  }
}
.takeRange {
  text-align: start;
  font-size: 20px;
  letter-spacing: .1em;
  font-family: Roboto;
  color: #6D6D6D;
  display: flex;
  align-items: center;
  span {
    color: #6D6D6D;
    // font-weight: 700;
    margin: 0;
    // color: #FF8B8B;
  }
  .num {
    display: inline-flex;
    width: 100px;
    height: 37px;
    border: 1px solid #CACACA;
    align-items: center;
    justify-content: center;
    letter-spacing: .05em;
    font-weight: 700;
    color: #FF8B8B;
    margin-inline: .5em;
  }
}
.rangeView {
  margin-left: 25px;
  border: 1px solid #CACACA;
  padding-inline: 20px;
  border-radius: 3px;
  height: 40px;
  width: 350px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  letter-spacing: .05em;
  &::after {
    content: '';
    width: 20px;
    height: 20px;
    display: inline-block;
    mask-image: url(./svg/icon/celender.svg);
    background-color: var(--color-pri);
    mask-repeat: no-repeat;
    mask-position: center;
    margin-left: auto;
  }
}
.inputtimeselect {
  display: flex;
  align-items: center;
  font-size: 20px;
  color: #5E5E5E;
  label {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
    input[type=radio] {
      width: 24px;
      height: 24px;
      appearance: none;
      border: 2px solid var(--color-pri);
      border-radius: 12px;
      &:checked {
        background-color: var(--color-checked);
        display: flex;
        align-items: center;
        justify-content: center;
        &::before {
          content: '';
          width: 10px;
          height: 10px;
          display: inline-block;
          background-color: #FFFFFF;
          border-radius: 10px;
        }
      }
    }
  }
  #setDateRange-input {
    text-align: flex-start;
    height: 40px;
    &::placeholder {
      text-align: center;
    }
  }
}
</style>
<style lang="scss" scoped>
.temperatures {
  display: flex;
  flex-direction: column;
  max-width: 400px;
  font-size: 20px;
  color: var(--color-pri);
  gap: 10px;
  &.outlying {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    max-width: 100%;
  }
  &.edit {
    max-width: 700px;
  }
  &>div{
    border: 1px solid var(--color-pri);
    padding: 10px;
    gap: 10px;
    display: flex;
    flex-direction: column;
    &>div{
      display: flex;
      align-items: center;
      &>div{
        display: flex;
        align-items: center;
      }
    }
  }
  .addbox {
    width: 85px;
    display: flex;
    padding-left: 10px;
  }
  .add {
    background-color: var(--highlight);
    mask-image: url(/svg/btn/plusSqr.svg);
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: 30px;
    width: 40px;
    height: 40px;
  }
  .remove {
    background-color: #CACACA;
    mask-image: url(/svg/btn/closesqr.svg);
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: 30px;
    width: 40px;
    height: 40px;
  }
  .editline {
    display: flex;
    gap: 10px;
  }
  input[type=text] {
    font-size: 20px;
    width: 100px;
    height: 40px;
    text-align: center;
    border-radius: 3px;
    border: 1px solid #CACACA;
  }
}
.containerB-box {
  display: flex;
  font-size: 20px;
  gap: 16px;
  align-items: center;
  color: #5E5E5E;
}
.btns{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 28px;
  width: 100%;
  button {
    &:disabled {
      filter: contrast(.5);
    }
    border: none;
    width: 100px;
    height: 35px;
    border-radius: 20px;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    &.confirm {
      background: #FF8B8B;
    }
    &.cancel {
      background: #B8B8B8;
    }
  }
}
.editBtn {
  margin-left: auto;
  width: 35px;
  height: 35px;
  background-color: var(--color-pri);
  background-image: url(./pen.svg);
  background-position: center;
  background-repeat: no-repeat;
  border: none;
  border-radius: 50%;
  background-size: 19px;
}
.attendance {
  height: 50px;
  display: block;
  font-weight: 400;
  font-size: 25px;
  letter-spacing: 0.1em;
  color: var(--color-pri);
  font-family: 'Roboto';
  &>div {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 80px;
  }
  &>div>div {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    &::after {
      content: '%';
    }
  }
  input {
    width: 100px;
    height: 40px;
    background: #FFFFFF;
    border: 1px solid #C4C4C4;
    border-radius: 3px;
    font-weight: 700;
    font-size: 20px;
    text-align: center;
    font-family: Roboto;
    letter-spacing: 2px;
    color: #FF8B8B;
      }
}
.switchs {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 15px;
  margin-bottom: 15px;
  &>div:nth-child(2) {
    display: flex;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    width: 100%;
    height: fit-content;
    align-items: center;
    justify-content: flex-start;
    margin-block: 10px 30px;

    &>div {
      width: 100px;
      height: fit-content;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: column;
      padding: 33.5px 20px;
      border: 2px dashed var(--color-pri);
      border-radius: 5px;
      gap: 20px;
      &::before {
        content: attr(label);
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 23px;
        letter-spacing: 0.1em;
        color: var(--color-letter);
      }
      &.min {
        width: 260px;
      }
      &.min::after{
        content: attr(after);
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 23px;
        letter-spacing: 0.1em;
        color: var(--color-letter);
        align-self: x;
      }
    }
    input[type=text] {
      height: 40px;
      width: 100px;
      border: 1px solid #C4C4C4;
      text-align: center;
      font-size: 20px;
      font-weight: 700;
      font-family: Roboto;
      letter-spacing: 2px;
      color: #FF8B8B;
    }
    input[type=checkbox] {
      appearance: none;
      width: 39px;
      height: 20px;
      border-radius: 10px;
      position: relative;
        background-color: #FF8B8B;
      &:checked {
        background-color: #85B8B9;
      }
      &::before {
        content: '';
        display: inline-flex;
        width: 16px;
        height: 16px;
        position: absolute;
        left: 2px;
        right: auto;
        top: 2px;
        background-color: #FFFFFF;
        border-radius: 8px;
      }
      &:checked::before {
        right: 2px;
        left: auto;
      }
      &.invert {
        background-color: #85B8B9;
        &:checked {
          background-color: #FF8B8B;
        }
      }
    }
  }
  &>div:nth-child(1) {
    font-family: "Noto Sans TC";
    font-style: normal;
    font-weight: 400;
    font-size: 25px;
    line-height: 29px;
    letter-spacing: 0.1em;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: var(--color-pri);
    width: -webkit-fill-available;

  }
}
.boxx {
  &>div:nth-child(1) {
    font-family: "Noto Sans TC";
    font-style: normal;
    font-weight: 400;
    font-size: 25px;
    line-height: 29px;
    letter-spacing: 0.1em;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: var(--color-pri);
    width: -webkit-fill-available;
  }
}
.restbooktimeset {
  display: grid;
  &>div{
    &:nth-child(1) {
      padding: 25px 53px 25px 82px;
    }
    &:nth-child(2) {
      border-left: 1px solid var(--color-pri);
      &>div{
        padding: 25px 50px 25px 50px;
      }
      //
    }
    box-sizing: border-box;
    overflow-y: auto;
    height: calc(100vh - 90px);
  }
}

.desc {
  margin-top: 26px;
  color: var(--unnamed, #6D6D6D);
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 2px;
  gap: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
    input[type=text] {
      height: 40px;
      width: 100px;
      border: 1px solid #C4C4C4;
      text-align: center;
      font-size: 20px;
      font-weight: 700;
      font-family: Roboto;
      letter-spacing: 2px;
      color: #FF8B8B;
    }
    select {
      height: 40px;
      border: 1px solid #C4C4C4;
      border-radius: 3px;
      margin-right: 3px;
    }
  span {
    color: var(--unnamed, #FF8B8B);
    font-family: Noto Sans TC;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 30px */
    letter-spacing: 1px;
    margin-inline: .5em;
    &:nth-child(odd) {
      display: inline-flex;
      border: 1px solid #CACACA;
      width: 100px;
      height: 37px;
      align-items: center;
      justify-content: center;

    }
  }
}
</style>
